
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/sections/components/ChildBoxes/ChildBoxes.scss.css.virtualfile';
        module.exports = {"box":"_box_1daly_7","siteSegment":"_siteSegment_1daly_12"};